import { Col, Row, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";

const NoPerMissionAdvert = () => {
  const { Text } = Typography;
  return (
    <>
      <Row gutter={[0,20]} className="">
        <Col xs={24} className="!grid gap-2" >
        <div className="!flex justify-center ">
          <Text className="!text-4xl !text-black !font-bold">
            İlan Verme Yetkiniz Bulunmuyor
          </Text>

        </div>
        <div className="!flex justify-center ">
        <Text className="!text-lg !text-gray-400 ">
            İlan verme yetkiniz için yöneticinize iletişime geçebilirsiniz
          </Text>
        </div>
        </Col>
        <Col xs={24} className="!flex justify-center" >
            <LazyLoadImage
            
            wrapperHeight="500px"
           wrapperWidth="500px"
           src="https://cdni.iconscout.com/illustration/premium/thumb/access-denied-illustration-download-in-svg-png-gif-file-formats--not-have-permission-login-system-warning-issue-miscellaneous-pack-illustrations-4694107.png"
           alt=""
           classNames="!object-contain !w-auto"
            />
        </Col>
        
      </Row>
    </>
  );
};

export default NoPerMissionAdvert;
